/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translate a DNA or RNA coding sequence into protein using the standard genetic code. Choose a reading frame and, if you like, stop at the first stop codon. FASTA input is accepted and U is read as T.`)
};

const es_translate_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduce una secuencia codificante de ADN o ARN en proteína usando el código genético estándar. Elige un marco de lectura y, si quieres, detente en el primer codón de parada. Se acepta entrada en formato FASTA y la U se lee como T.`)
};

const de_translate_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzen Sie eine DNA- oder RNA-Kodierungssequenz mithilfe des Standard-genetischen Codes in ein Protein. Wählen Sie ein Leseraster und stoppen Sie bei Bedarf am ersten Stoppcodon. FASTA-Eingabe wird akzeptiert, und U wird als T gelesen.`)
};

const nl_translate_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertaal een coderende DNA- of RNA-sequentie naar eiwit met de standaard genetische code. Kies een leesframe en stop desgewenst bij het eerste stopcodon. FASTA-invoer wordt geaccepteerd en U wordt gelezen als T.`)
};

const fr_translate_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduisez une séquence codante d'ADN ou d'ARN en protéine à l'aide du code génétique standard. Choisissez un cadre de lecture et, si vous le souhaitez, arrêtez au premier codon stop. L'entrée FASTA est acceptée et U est lu comme T.`)
};

const it_translate_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduci una sequenza codificante di DNA o RNA in una proteina usando il codice genetico standard. Scegli una fase di lettura e, se vuoi, fermati al primo codone di stop. Accetta input FASTA e U viene letta come T.`)
};

const pt_br2_translate_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduza uma sequência codificante de DNA ou RNA em proteína usando o código genético padrão. Escolha um quadro de leitura e, se quiser, pare no primeiro códon de parada. Entrada em FASTA é aceita e U é lido como T.`)
};

const pt_translate_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduza uma sequência codificante de ADN ou ARN em proteína usando o código genético padrão. Escolha uma grelha de leitura e, se quiser, pare no primeiro codão de paragem. Aceita entrada FASTA e U é lido como T.`)
};

const ja_translate_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準遺伝暗号を使ってDNAまたはRNAコード配列をタンパク質に翻訳します。読み枠を選択し、必要であれば最初の終止コドンで停止できます。FASTA入力に対応し、Uはtとして読み取られます。`)
};

const zh_translate_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用标准遗传密码将 DNA 或 RNA 编码序列翻译为蛋白质。选择一个阅读框，如果需要，可以在遇到第一个终止密码子时停止。接受 FASTA 输入，U 按 T 处理。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_intro", locale)
	if (locale === "en") return en_translate_intro(inputs)
	if (locale === "es") return es_translate_intro(inputs)
	if (locale === "de") return de_translate_intro(inputs)
	if (locale === "nl") return nl_translate_intro(inputs)
	if (locale === "fr") return fr_translate_intro(inputs)
	if (locale === "it") return it_translate_intro(inputs)
	if (locale === "pt-BR") return pt_br2_translate_intro(inputs)
	if (locale === "pt") return pt_translate_intro(inputs)
	if (locale === "ja") return ja_translate_intro(inputs)
	return zh_translate_intro(inputs)
};